export default "__VITE_ASSET__409f5a66__"